import { PassengerAncillaryPricing, Prices } from "@b2bportal/air-booking-api";
import {
  /*
    TODO: delete once old prices is fully deprecated, see https://hopchat.slack.com/archives/C02LJBJTY67/p1676057816240079;
    here's its associated ticket https://hopper-jira.atlassian.net/browse/BF-1524
  */
  getAddedLegacyRewards,
  getAddedLegacyPrices,
  getModifiedLegacyRewards,
  getMultipliedLegacyPrices,
  // new prices helpers
  getAddedRewards,
  getAddedPrices,
  getSubtotalWithAncillaries,
  roundToTwoDecimals,
} from "halifax";

export const getCfarFee = (
  ancillaries: PassengerAncillaryPricing[] | undefined
): number | undefined =>
  ancillaries?.find(
    (ancillary: PassengerAncillaryPricing) => ancillary?.kind === "Cfar"
  )?.premium?.fiat?.value;

export const getDisruptionProtectionFee = (
  ancillaries: PassengerAncillaryPricing[] | undefined
): number | undefined =>
  ancillaries?.find(
    (ancillary: PassengerAncillaryPricing) =>
      ancillary?.kind === "Delay" || ancillary?.kind === "MissedConnection"
  )?.premium?.fiat?.value;

/**
 *
 * @param rewards
 * @returns Rounded rewards values based on currency type.
 */
export const roundRewards = (
  rewards: Prices["accountSpecific"]
): Prices["accountSpecific"] => {
  if (!rewards) {
    return {};
  }
  return Object.keys(rewards).reduce((acc, key) => {
    const rewardsPrice = rewards[key as keyof Prices["accountSpecific"]];

    if (rewardsPrice.currency === "Cash") {
      acc[key] = {
        ...rewardsPrice,
        value: roundToTwoDecimals(rewardsPrice.value),
      };
    } else {
      acc[key] = {
        ...rewardsPrice,
        value: Math.round(rewardsPrice.value),
      };
    }
    return acc;
  }, {});
};

export {
  getAddedLegacyRewards,
  getAddedLegacyPrices,
  getModifiedLegacyRewards,
  getMultipliedLegacyPrices,
  getAddedRewards,
  getAddedPrices,
  getSubtotalWithAncillaries,
};
